export enum ParameterCalculationMethod {
Fixed,
Parameter,
Expression,
Scale,
AutoCalculated,
}
